import { render } from "./corpBase.vue?vue&type=template&id=22159b1a&scoped=true"
import script from "./corpBase.vue?vue&type=script&lang=js"
export * from "./corpBase.vue?vue&type=script&lang=js"

import "./corpBase.vue?vue&type=style&index=0&id=22159b1a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22159b1a"]])

export default __exports__